import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Card, CardHeader } from 'reactstrap';
import { H4 } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import ManageAPK from "../../../../api/ManageAPK";

const ApkTable = ({ apks, reloadAction }) => {
  const { layoutURL } = useContext(CustomizerContext);
  /*const tableRef = useRef(null);
  const [loadingApkId, setLoadingApkId] = useState(null);

  useEffect(() => {
    const table = $(tableRef.current).DataTable({
      order: [[0, 'desc']],
      language: {
        processing:     "Traitement en cours...",
        search:         "Rechercher&nbsp;:",
        lengthMenu:     "Afficher _MENU_ éléments",
        info:           "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
        infoEmpty:      "Affichage de l'élément 0 à 0 sur 0 élément",
        infoFiltered:   "(filtré de _MAX_ éléments au total)",
        loadingRecords: "Chargement en cours...",
        zeroRecords:    "Aucun élément à afficher",
        emptyTable:     "Aucune donnée disponible dans le tableau",
        paginate: {
          first: "Premier",
          previous: "Précédent",
          next: "Suivant",
          last: "Dernier"
        },
        aria: {
          sortAscending: ": activer pour trier par ordre croissant",
          sortDescending: ": activer pour trier par ordre décroissant"
        }
      }
    });

    return () => table.destroy();
  }, []);

  const handlePublishApk = async (apk_id) => {
    try {
      setLoadingApkId(apk_id);
      await ManageAPK.publishApk({ apk_id });
      reloadAction();
    } catch (error) {
      console.error('Erreur lors de la publication de l’APK:', error);
    } finally {
      setLoadingApkId(null);
    }
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      const table = $(tableRef.current).DataTable();
      table.clear();

      apks.forEach((apk) => {
        table.row.add([
          apk.apk_name,
          `
            <button 
              class='btn btn-sm btn-primary publish-btn' 
              data-apkid='${apk.id}'
              ${loadingApkId === apk.id ? 'disabled' : ''}
            >
              ${loadingApkId === apk.id ? '<span class="spinner-border spinner-border-sm"></span> Publication...' : '<i class="fa fa-cloud-upload"></i> Publier'}
            </button>
          `
        ]);
      });

      table.draw();

      // Attach click handler
      $(tableRef.current).off('click', '.publish-btn').on('click', '.publish-btn', function () {
        const apk_id = parseInt($(this).data('apkid'));
        handlePublishApk(apk_id);
      });
    }
  }, [apks, loadingApkId]);*/

  const handlePublishApk = async (apkId) => {
    try {
      await ManageAPK.publishApk({ apk_id: apkId });
      //reloadAction(); // recharge la liste après publication
    } catch (error) {
      console.error('Erreur lors de la publication de l’APK :', error);
    }
  };

  return (
      <Fragment>
        <Card>
          <CardHeader>
            <H4 attrH4={{ className: 'card-title mb-0' }}>Liste des APKs</H4>
            <div className='card-options'>
              <a className='card-options-collapse' href='#javascript' data-toggle='card-collapse'>
                <i className='fe fe-chevron-up'></i>
              </a>
              <a className='card-options-remove' href='#javascript' data-toggle='card-remove'>
                <i className='fe fe-x'></i>
              </a>
            </div>
          </CardHeader>
          <div className='table-responsive edit-table'>
            <table
                className='display table table-striped table-vcenter text-nowrap'
                style={{ width: '100%' }}
            >
              <thead>
              <tr>
                <th>ID</th>
                <th>Nom de l'APK</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              {apks.map((apk, i) => (
                  <tr key={i}>
                    <td>{apk.id}</td>
                    <td>{apk.apk_name}</td>
                    <td>
                      <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handlePublishApk(apk.id)}
                      >
                        Publier
                      </button>
                    </td>
                  </tr>
              ))}
              </tbody>
            </table>
          </div>
        </Card>
      </Fragment>
  );
};

export default ApkTable;
